import { render, staticRenderFns } from "./noDataVillage.vue?vue&type=template&id=419f7e3f&scoped=true&"
import script from "./noDataVillage.vue?vue&type=script&lang=js&"
export * from "./noDataVillage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "419f7e3f",
  null
  
)

export default component.exports